import { BancoDto } from "src/app/pagamento/models/banco-dto";

export const BANCO_DTO: BancoDto[] = [
  { codigo: 1, nome: "BANCO DO BRASIL S A" },
  { codigo: 5, nome: "BANCO DO BRASIL S A" },
  { codigo: 8, nome: "BANCO SANTANDER MERIDIONAL S/A" },
  { codigo: 47, nome: "BANCO DO ESTADO DE SERGIPE S/A" },
  { codigo: 104, nome: "CAIXA ECONOMICA FEDERAL" },
  { codigo: 237, nome: "BANCO BRADESCO S.A." },
  { codigo: 341, nome: "BANCO ITAU S A" },
  { codigo: 745, nome: "BANCO CITIBANK S.A." },
];